export default __webpack_public_path__ + "static/media/hen.dfd6c10c.png";